// removed by extract-text-webpack-plugin
module.exports = {"compare_icon_array":"CompareIconArray--compare_icon_array--1DzjS"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/CompareIconArray/CompareIconArray.css
// module id = 1015
// module chunks = 0